import { useInstantSearch } from 'react-instantsearch';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { FilterTitle } from '@sorare/core/src/components/search/FilterTitle';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { FILTERS, TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';
import { powerAlgorithm } from '@sorare/core/src/lib/slider';

import { RangeSlider } from '#src/search/RangeSlider/index.tsx';
import { makeRangeFilter } from '#src/searchCards/RangeSlider/index.tsx';

import { jerseySerialWidget } from './RefineJerseySerial/index.tsx';

const FILTER = FILTERS.serialNumber;

const refineSerialNumberAlgorithm = powerAlgorithm({ power: 2 });

const SerialNumberTitle = () => {
  const { indexUiState } = useInstantSearch();

  const selected =
    !!indexUiState.range?.[FILTER.attribute] ||
    !!indexUiState.toggle?.[TOGGLE_FILTERS.jerseySerialFilter.attribute];

  return <FilterTitle name={FILTER.title} selected={selected} />;
};

export const RefineSerialNumber: FilterWidget = {
  ...makeRangeFilter(({ visible }) => {
    return (
      <Vertical gap={2}>
        <RangeSlider
          attribute={FILTERS.serialNumber.attribute}
          algorithm={refineSerialNumberAlgorithm}
          toInput={(value: number) => Math.round(value).toString()}
          visible={visible}
        />
        {jerseySerialWidget.Component({ visible })}
      </Vertical>
    );
  }, FILTERS.serialNumber),
  title: <SerialNumberTitle />,
};
